import { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { apiError } from "@/lib/apiClient";
import { Rocket, Loader2 } from "lucide-react";
import { toast } from "sonner";

export default function Register() {
  const { register } = useAuth();
  const navigate = useNavigate();
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError("");
    try {
      await register(email, password, name);
      toast.success("Account created");
      navigate("/");
    } catch (err) {
      setError(apiError(err));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-[#0A0A0A] text-white flex items-center justify-center px-6 py-12">
      <form onSubmit={submit} className="w-full max-w-sm" data-testid="register-form">
        <Link to="/login" className="flex items-center gap-2 mb-10">
          <div className="h-8 w-8 rounded-md bg-white flex items-center justify-center">
            <Rocket className="h-4 w-4 text-black" strokeWidth={2} />
          </div>
          <span className="font-heading text-lg font-bold tracking-tight">DeployBridge</span>
        </Link>
        <h1 className="font-heading text-3xl font-medium tracking-tight mb-2">Create account</h1>
        <p className="text-sm text-neutral-400 mb-8">Start deploying in minutes.</p>

        <label className="block text-sm text-neutral-300 mb-1.5">Name</label>
        <input
          value={name}
          onChange={(e) => setName(e.target.value)}
          data-testid="register-name-input"
          className="w-full h-10 rounded-md border border-[#262626] bg-[#141414] px-3 text-sm mb-4 outline-none focus:ring-2 focus:ring-neutral-500"
          placeholder="Ada Lovelace"
        />
        <label className="block text-sm text-neutral-300 mb-1.5">Email</label>
        <input
          type="email"
          required
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          data-testid="register-email-input"
          className="w-full h-10 rounded-md border border-[#262626] bg-[#141414] px-3 text-sm mb-4 outline-none focus:ring-2 focus:ring-neutral-500"
          placeholder="you@example.com"
        />
        <label className="block text-sm text-neutral-300 mb-1.5">Password</label>
        <input
          type="password"
          required
          minLength={6}
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          data-testid="register-password-input"
          className="w-full h-10 rounded-md border border-[#262626] bg-[#141414] px-3 text-sm mb-2 outline-none focus:ring-2 focus:ring-neutral-500"
          placeholder="At least 6 characters"
        />
        {error && <p className="text-sm text-red-400 mb-3" data-testid="register-error">{error}</p>}
        <button
          type="submit"
          disabled={loading}
          data-testid="register-submit-button"
          className="mt-4 w-full h-10 rounded-md bg-white text-black text-sm font-medium hover:bg-neutral-200 transition-colors duration-200 flex items-center justify-center disabled:opacity-60"
        >
          {loading ? <Loader2 className="h-4 w-4 animate-spin" /> : "Create account"}
        </button>
        <p className="text-sm text-neutral-500 mt-6">
          Already have an account?{" "}
          <Link to="/login" className="text-white underline underline-offset-4" data-testid="go-login">
            Sign in
          </Link>
        </p>
      </form>
    </div>
  );
}
